import { jsxs as o, jsx as r } from "react/jsx-runtime";
import e from "./hero-full-width-image.module.less.js";
import { getImageLoading as u } from "../../../helpers/image-helper.js";
import "dayjs";
import { useIntersectionObserver as h } from "usehooks-ts";
import a from "../../../animation/animation.module.less.js";
const y = ({
  imageDesktop: i,
  imageMobile: t,
  enableImageOverlay: m,
  blockIndex: s,
  fallbackDesktopImage: n
}) => {
  const { isIntersecting: l, ref: c } = h({
    threshold: 0,
    freezeOnceVisible: !0
  }), d = [
    s === 0 ? a.fadeIn400 : l ? a.fadeIn400 : "",
    a.opacity0
  ].join(" ");
  return /* @__PURE__ */ o("div", { className: d, children: [
    m && /* @__PURE__ */ r("div", { className: e.imageOverlay }),
    /* @__PURE__ */ r(
      "div",
      {
        ref: c,
        className: [e.fullWidthImageWrapper, m ? e.enableImageOverlay : ""].join(" "),
        children: (i?.url || t?.url) && /* @__PURE__ */ o("picture", { children: [
          /* @__PURE__ */ r("source", { srcSet: t?.url, media: "(max-width: 767px)" }),
          /* @__PURE__ */ r("source", { srcSet: i?.url || n, media: "(min-width: 768px)" }),
          /* @__PURE__ */ r(
            "img",
            {
              fetchPriority: s === 0 ? "high" : "auto",
              src: i?.url || n,
              className: e.image,
              alt: t?.alt || i?.alt,
              loading: u(s)
            }
          )
        ] })
      }
    )
  ] });
};
export {
  y as default
};
